var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9991 3.3999C7.24946 3.3999 3.39911 7.25025 3.39911 11.9999C3.39911 16.7495 7.24946 20.5999 11.9991 20.5999C13.53 20.5999 14.9646 20.2008 16.2078 19.5016C16.4305 19.3764 16.6927 19.3412 16.9405 19.4031L20.4007 20.2681L19.7937 16.0193C19.7672 15.8339 19.7933 15.6448 19.869 15.4735C20.3381 14.4125 20.5991 13.238 20.5991 11.9999C20.5991 7.25025 16.7488 3.3999 11.9991 3.3999ZM1.39911 11.9999C1.39911 6.14568 6.14489 1.3999 11.9991 1.3999C17.8533 1.3999 22.5991 6.14568 22.5991 11.9999C22.5991 13.4182 22.32 14.7736 21.813 16.0125L22.5909 21.4576C22.638 21.7872 22.5179 22.1186 22.2707 22.3416C22.0234 22.5646 21.6814 22.6499 21.3584 22.5691L16.8304 21.4371C15.3807 22.1806 13.7376 22.5999 11.9991 22.5999C6.14489 22.5999 1.39911 17.8541 1.39911 11.9999Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6938 11.8999C14.6938 11.2095 15.2535 10.6499 15.9438 10.6499H15.9528C16.6432 10.6499 17.2028 11.2095 17.2028 11.8999C17.2028 12.5903 16.6432 13.1499 15.9528 13.1499H15.9438C15.2535 13.1499 14.6938 12.5903 14.6938 11.8999Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6849 11.8999C10.6849 11.2095 11.2445 10.6499 11.9349 10.6499H11.9439C12.6343 10.6499 13.1939 11.2095 13.1939 11.8999C13.1939 12.5903 12.6343 13.1499 11.9439 13.1499H11.9349C11.2445 13.1499 10.6849 12.5903 10.6849 11.8999Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.67618 11.8999C6.67618 11.2095 7.23583 10.6499 7.92618 10.6499H7.93518C8.62554 10.6499 9.18518 11.2095 9.18518 11.8999C9.18518 12.5903 8.62554 13.1499 7.93518 13.1499H7.92618C7.23583 13.1499 6.67618 12.5903 6.67618 11.8999Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.0ca80a28126930c63993dcce31af44df.svg";
export { ForwardRef as ReactComponent };